import type { LucideIcon } from "lucide-react";

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-4 py-12 text-center">
      {Icon && (
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-line-soft text-muted">
          <Icon className="h-5 w-5" strokeWidth={1.8} />
        </div>
      )}
      <div className="text-sm font-semibold text-ink">{title}</div>
      {description && <div className="max-w-md text-balance text-xs text-muted">{description}</div>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
